
// Operation queue to prevent race conditions (ES5 compatible)
var isProcessingCartOperation = false;
var operationQueue = [];

// Process operations one by one
function processOperationQueue() {
  if (isProcessingCartOperation || operationQueue.length === 0) return;
  
  isProcessingCartOperation = true;
  var operation = operationQueue.shift();
  
  operation()
    .then(function() {
      isProcessingCartOperation = false;
      // Process next operation after a small delay
      setTimeout(processOperationQueue, 100);
    })
    .catch(function(error) {
      isProcessingCartOperation = false;
      setTimeout(processOperationQueue, 100);
    });
}

// Helper to attach add-to-cart behavior to current forms
function bindMasterCollectionAddToCart() {
  var forms = document.querySelectorAll('.add-to-cart-form');
  
  for (var i = 0; i < forms.length; i++) {
    var form = forms[i];
    
    // Skip if already bound to prevent duplicate listeners
    if (form.dataset.bound) {
      continue;
    }
    form.dataset.bound = 'true';
    
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var button = e.target.querySelector('.add-to-cart-btn');
      var variantId = e.target.querySelector('[name="id"]').value;
      var cartDrawer = document.querySelector('cart-drawer');
      var originalText = button.textContent;


      // Prevent multiple submissions
      if (button.disabled || button.classList.contains('loading')) {
        return;
      }
      
      // Add to operation queue
      operationQueue.push(function() {
        return performAddToCart(button, variantId, cartDrawer, originalText);
      });
      processOperationQueue();
    });
  }
}

// Extracted add to cart function for better control
function performAddToCart(button, variantId, cartDrawer, originalText) {
  // Set loading state
  button.disabled = true;
  button.classList.add('loading');
  button.textContent = 'Adding...';

  return fetch(routes.cart_add_url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: cartDrawer ? ['cart-drawer'] : [],
      sections_url: window.location.pathname
    })
  })
  .then(function(response) {
    if (!response.ok) {
      return response.json().then(function(error) {
        button.textContent = 'Error';
        return new Promise(function(resolve) {
          setTimeout(function() {
            button.textContent = originalText;
            button.disabled = false;
            button.classList.remove('loading');
            resolve();
          }, 2000);
        });
      });
    }

    return response.json().then(function(parsedState) {
      // Show success feedback
      button.textContent = 'Added!';
      
      // Open cart drawer
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsedState);
        cartDrawer.open();
      }
      
      // Wait before resetting
      return new Promise(function(resolve) {
        setTimeout(function() {
          button.textContent = originalText;
          button.disabled = false;
          button.classList.remove('loading');
          resolve();
        }, 1500);
      });
    });
  })
  .catch(function(error) {
    button.textContent = 'Error';
    return new Promise(function(resolve) {
      setTimeout(function() {
        button.textContent = originalText;
        button.disabled = false;
        button.classList.remove('loading');
        resolve();
      }, 2000);
    });
  });
}

// Helper to prevent card link click when button is pressed
function bindMasterCollectionCardButtons() {
  var cartButtons = document.querySelectorAll('.add-to-cart-btn');

  for (var i = 0; i < cartButtons.length; i++) {
    cartButtons[i].addEventListener('click', function (event) {
      event.stopPropagation();
    });
  }
}

// Render master collection grid items from global `productsbundle`
function renderMasterCollectionGridFromBundle() {
  if (typeof productsbundle === 'undefined' || !Array.isArray(productsbundle)) return;

  var track = document.querySelector('.master-collection-grid__track');
  if (!track) return;

  var html = '';
  for (var i = 0; i < productsbundle.length; i++) {
    var p = productsbundle[i];
    var hasCompare = p.compare_at_price_max && p.compare_at_price_max > p.price;
    var imageHtml = '';
    
    if (p.featured_image && p.featured_image !== "" && p.featured_image.indexOf('data:image') === -1) {
      imageHtml = '<img src="' + p.featured_image + '" alt="' + p.title + '" loading="lazy">';
    }
    
    var priceHtml = '';
    if (hasCompare) {
      priceHtml = '<span class="regular-price">' + p.regular_price + '</span><span class="sale-price">' + p.sale_price + '</span>';
    } else {
      priceHtml = p.sale_price;
    }
    
    var badgeHtml = '';
    if (p.metafields && p.metafields.judgeme) {
      badgeHtml = p.metafields.judgeme.badge;
    }

    html += '<div class="master-collection-grid__item">' +
      '<a href="' + p.url + '" class="product-link">' +
        imageHtml +
        '<div class="product-title">' + p.title + '</div>' +
      '</a>' +
      '<div class="jdgm-widget jdgm-preview-badge" data-id="' + p.id + '" data-auto-install="false">' +
        badgeHtml +
      '</div>' +
      '<div class="product-price">' + priceHtml + '</div>' +
      (p.flavors_html || '') +
      '<form class="add-to-cart-form">' +
        '<input type="hidden" name="id" value="' + p.variant_id + '">' +
        '<button type="submit" class="add-to-cart-btn tertiary-btn">Add to cart</button>' +
      '</form>' +
    '</div>';
  }
  
  track.innerHTML = html;

  // Re-bind behaviors for the newly rendered DOM
  bindMasterCollectionAddToCart();
  bindMasterCollectionCardButtons();
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  bindMasterCollectionAddToCart();
  bindMasterCollectionCardButtons();
});